var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-results"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.text)}}),_c('TotemButton',{staticClass:"no-results__button",attrs:{"color":"primary","label":_vm.buttonLabel},on:{"click":_vm.onClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }